<div class="br-flex br-flex-column br-vh-full">
  <ng-container *ngIf="isStandaloneRoute; else staffShell">
    <router-outlet></router-outlet>
  </ng-container>

  <ng-template #staffShell>
    <div class="br-flex-grow-1 br-position-relative app-shell"
         [class.sidebar-expanded]="sidebarExpanded">
      <ng-container *ngIf="auth.isAuthenticated(); else landing">
        <app-map></app-map>

        <app-sidebar [(expanded)]="sidebarExpanded"
          [activeViewTab]="activeViewTab"
          (viewTabChange)="onViewTabChange($event)">
        </app-sidebar>

        <div class="map-legends">
          <app-prospect-legend></app-prospect-legend>
          <app-density-legend></app-density-legend>
        </div>

        <app-command-bar
          class="workspace-chat-resize"
          [appResizeX]="workspaceHasAssistantGutter ? '--ws-chat-w' : ''"
          [resizeMin]="300"
          [resizeMax]="600"
          [resizeViewportInset]="320"
          resizeEdge="left">
        </app-command-bar>

        <div class="map-zoom" *ngIf="!onRoutedPage" matTooltip="Current map zoom">
          <span class="zoom-badge">Z</span>{{ zoom }}
        </div>

        <app-workspace
          [open]="onRoutedPage"
          [canBack]="!!contextNavigation?.canBack"
          [canForward]="!!contextNavigation?.canForward"
          (backRequested)="contextNavigation?.back()"
          (forwardRequested)="contextNavigation?.forward()"
          [breadcrumbs]="breadcrumbs"
          [maximized]="cardMaximized"
          [dockedRight]="cardDockedRight"
          (dockRightRequested)="toggleDockRight()"
          (maximizeRequested)="toggleMaximize()"
          (closeRequested)="closeCard()">
        </app-workspace>
      </ng-container>

      <ng-template #landing>
        <app-landing></app-landing>
      </ng-template>
    </div>
  </ng-template>
</div>
